<template>
	<div class="pt-10" id="search">
		<div class="w-full flex justify-center container px-3 mx-auto">
			<input
				type="text"
				placeholder="Search for something amazing"
				class="bg-gray-800 text-gray-300 focus:shadow-outline shadow w-1/2 rounded-full py-3 px-5 w-full"
				v-on:input="search($event.target.value)"
			/>
		</div>
		<div
			class="w-full flex flex-wrap container mx-auto"
			v-if="loading === false"
		>
			<SearchResult
				v-for="song in res"
				v-bind:key="song.result.id"
				:link="'/song/' + song.result.id"
				:title="song.result.full_title"
				:image="song.result.header_image_url"
			/>
		</div>
		<div class="mt-10" v-else>
			<div class="loading">
				<div class="ball bg-indigo-400"></div>
				<div class="ball bg-indigo-400"></div>
				<div class="ball bg-indigo-400"></div>
			</div>
		</div>
	</div>
</template>

<script>
import SearchResult from './searchResult.vue';
import axios from 'axios';
export default {
	name: 'Search',
	data: () => {
		return {
			searchText: '',
			res: {},
			loading: false
		};
	},
	components: {
		SearchResult
	},
	methods: {
		search: async function(val) {
			this.loading = true;
			const that = this;
			await axios
				.get(
					`https://api.genius.com/search?q=${val}&access_token=DAwGk4MUWCAT3R5WlGUWVy7TCfyXrHyUNn52O9snc17yhn51c7CcU4GQMfJ5lQcU`
				)
				.then(res => {
					that.res = res.data.response.hits;
				})
				.finally(() => (that.loading = false));
		}
	}
};
</script>
